<template>
  <div class="question-no-comment">
    <img class="img" :src="image" alt="">
    <p>还没有评论~</p>
  </div>
</template>

<script setup>
import NoCommentImg from "../img/no-comment.png"
const image = NoCommentImg
</script>

<style lang="scss" scoped>
.question-no-comment {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: transparent;
  border-radius: 0.12rem;
  padding: 0.46rem 0 0.48rem;
  .img {
    width: 3.14rem;
  }
  p {
    margin-top: 0.14rem;
    color: #969799;
    font-size: 0.28rem;
  }
}
</style>
